import { Descriptions, Row, Button, Divider, Spin, Modal, Form } from "antd";
import cpfMask from "../../../utils/getCpfMask";
import phoneMask from "../../../utils/getPhoneMask";
import { ArrowLeftOutlined, DownloadOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Wrapper } from './styles';
import { EstagioService } from '../../../services/estagio.service';
import { toast } from "react-toastify";
import FormItem from "antd/lib/form/FormItem";
import TextArea from "antd/lib/input/TextArea";


export function DetalhesEstagio() {
  const { estagiario } = useParams();
  const history = useHistory();
  const [fichas, setFichas] = useState([]);
  const dateOptions = { timeZone: 'UTC', month: 'numeric', day: 'numeric', year: 'numeric' };
  const [isloading, setIsLoading] = useState(true);
  const [modalIndeferir, setModalIndeferir] = useState(false);
  const [fichaIndeferir, setFichaIndeferir] = useState({});
  const [form] = Form.useForm();


  useEffect(() => {
    atualizaFicha();

  }, [])

  const atualizaFicha = async () => {
    setIsLoading(true);
    // console.log(estagiario);
    try {
      await EstagioService.findByCpf(estagiario).then(({ data }) => {
        setFichas(data);
        // console.log("Estagiario " , data);
      })

    }
    catch {

      console.log("Erro ao recuperar cursos")

    } finally {
      setIsLoading(false);
    }

  }

  const deferirInscricao = async (id, ficha) => {
    setIsLoading(true);
    ficha['situacao'] = 'DEFERIDO';
    ficha['justificativa'] = 'Inscrição Deferida';
    // console.log(ficha);
    try {
      await EstagioService.alteraInscricao(id, ficha);
      toast.success("Inscrição Deferida com Sucesso");

    }
    catch {
      console.log("Falha ao Atualizar Status");
      toast.error("Falha ao Atualizar Status");
    }
    finally {
      setIsLoading(false);

    }

  }
  const indeferirInscricao = async (id, ficha) => {
    setIsLoading(true);
    ficha['situacao'] = 'INDEFERIDO';
    // console.log(ficha);
    try {
      await EstagioService.alteraInscricao(id, ficha);
      toast.error("Incrição Indeferida com Sucesso", "Teste");
    }
    catch {
      console.log("Falha ao Atualizar Status");
      toast.error("Falha ao Atualizar Status");
    }
    finally {
      setIsLoading(false);
      setModalIndeferir(false);

    }

  }

  function downloadPDF(pdf, name) {
    // const linkSource = `data:application/pdf;base64,${pdf}`;
    // console.log(linkSource);
    const downloadLink = document.createElement("a");
    const fileName = name;

    downloadLink.href = pdf;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  const handleOk = (values) => {
    fichaIndeferir["justificativa"] = values["justificativa"]
    indeferirInscricao(fichaIndeferir.id, fichaIndeferir);
    form.resetFields();

  };
  const handleCancel = () => {
    setModalIndeferir(false);
    form.resetFields();
  };


  return (
    <Spin
      spinning={isloading}
      style={{
        marginTop: "400px",
        position: "fixed",
      }}
    >
      <div>
        {fichas.map((ficha, index) => (
          <Wrapper>
            <Modal
              title="Confirmar Indeferimento"
              visible={modalIndeferir}
              className="conteudoModal"
              onCancel={handleCancel}
              footer={[]}
            >
              <Form form={form} onFinish={handleOk} style={{}}>
                <FormItem name="justificativa" style={{ width: "100%" }} rules={[
                  {
                    required: true,
                    message: 'Informe a Justificativa',
                  },
                ]}>
                  <TextArea placeholder="Inserir Justificativa" name = "justificativa" rows={4}  />
               </FormItem>     
               <Button style={{ background: 'orange', border:'none', align: 'right', position: 'absolute',right: '10px' }} type="primary" shape="round"  key="submit" type="primary" htmlType="submit">Confirmar Indeferimento</Button>
            </Form>
            
          </Modal>
              <Row justify='center' align='middle'>
                <div className="ant-descriptions-title"> <ArrowLeftOutlined onClick={() => history.goBack()} /> Dados do Estagiário</div>

              </Row>
              <div key={ficha.id}>

                <Divider > Data da Inscrição: {ficha.dataCriacao ? new Date(ficha.dataCriacao).toLocaleDateString('pt-BR', dateOptions) : " "} </Divider >
                <Descriptions span={2} >
                  <Descriptions.Item span={2} label="Nome">{ficha.nome.toUpperCase()}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Status da Inscrição"><b>{ficha.situacao ? ficha.situacao : "INSCRITO"}</b></Descriptions.Item>
                  <Descriptions.Item span={2} label="CPF">{cpfMask(ficha.cpf)}</Descriptions.Item>
                  <Descriptions.Item span={2} label="RG">{ficha.rg}</Descriptions.Item>
                  <Descriptions.Item span={2} label="UF RG">{ficha.estadoRg.toUpperCase()}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Data Nascimento">{(ficha.dataNascimento ? new Date(ficha.dataNascimento).toLocaleDateString() : '')}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Orgão Expedidor">{ficha.orgaoExpedidor}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Gênero">{ficha.genero.toUpperCase()}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Estado Civil">{ficha.estadoCivil}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Nome Mãe">{ficha.nomeMae.toUpperCase()}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Nome Pai">{ficha.nomePai ? ficha.nomePai.toUpperCase() : "NÃO INFORMADO"}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Endereço">{ficha.endereco.toUpperCase()}</Descriptions.Item>
                  <Descriptions.Item span={2} label="CEP">{ficha.cep}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Número">{ficha.numero}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Complemento">{ficha.complemento ? ficha.complemento.toUpperCase() : "NÃO"}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Bairro">{ficha.bairro.toUpperCase()}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Cidade">{ficha.cidade.toUpperCase()}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Email">{ficha.email.toUpperCase()}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Telefone">{phoneMask(ficha.telefone)}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Curso">{ficha.curso}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Semestre">{ficha.semestre.toUpperCase()}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Instituição">{ficha.instituicao}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Turno do Curso">{ficha.turnoCurso}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Turno Disponivel">{ficha.turnoDisponibilidade}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Número da Inscrição">{ficha.id.toUpperCase()}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Deficiente">{ficha.deficiente ? "SIM" : "NÃO"}</Descriptions.Item>
                  <Descriptions.Item span={2} label="Justificativa">{ficha.justificativa? ficha.justificativa : "NÃO"}</Descriptions.Item>


                </Descriptions>

                <div className="areaButton">

                  <Button type="primary" shape="round" icon={<DownloadOutlined />} onClick={() => {
                    downloadPDF(ficha.anexoDeclaracaoMatricula, "Declaracao_" + ficha.nome);
                    // console.log("Declaracao: "+ficha.anexoDeclaracaoMatricula.split(",")[1])
                    // let pdfWindow = window.open("");
                    // pdfWindow.document.write(
                    //   "<iframe width='100%' height='100%' src='" +
                    //   encodeURI(ficha.anexoDeclaracaoMatricula) +
                    //   "'></iframe>"
                    // );
                  }} >
                    Declaração de Matrícula
                  </Button>
                  <Button type="primary" shape="round" icon={<DownloadOutlined />} onClick={() => {
                    // console.log("Declaracao: "+ficha.anexoDeclaracaoMatricula.split(",")[1])
                    downloadPDF(ficha.anexoCurriculo, "Curriculo_" + ficha.nome);
                    // let pdfWindow = window.open("");
                    // pdfWindow.document.write(
                    //   "<iframe width='100%' height='100%' src='" +
                    //   encodeURI(ficha.anexoCurriculo) +
                    //   "'></iframe>"
                    // );
                  }}  >
                    Currículo
                  </Button>
                </div>
                <div className="areaButton">
                  <Button type="primary" shape="round" icon={<DownloadOutlined />} onClick={() => {
                    downloadPDF(ficha.anexoHistoricoAcademico, "Historico_" + ficha.nome);
                    // console.log("Declaracao: "+ficha.anexoDeclaracaoMatricula.split(",")[1])
                    // let pdfWindow = window.open("");
                    // pdfWindow.document.write(
                    //   "<iframe width='100%' height='100%' src='" +
                    //   encodeURI(ficha.anexoHistoricoAcademico) +
                    //   "'></iframe>"
                    // );
                  }}  >
                    Histórico Academico
                  </Button>
                  <Button type="primary" shape="round" icon={<DownloadOutlined />} onClick={() => {
                    downloadPDF(ficha.anexoCopiaRG, "RG_" + ficha.nome);
                    // console.log("Declaracao: "+ficha.anexoDeclaracaoMatricula.split(",")[1])
                    // let pdfWindow = window.open("");
                    // pdfWindow.document.write(
                    //   "<iframe width='100%' height='100%' src='" +
                    //   encodeURI(ficha.anexoCopiaRG) +
                    //   "'></iframe>"
                    // );
                  }}  >
                    Cópia RG
                  </Button>

                </div>

                <div className="areaButtonSubmit" justify="center"  >

                  <Button style={{ background: 'orange' }} type="primary" shape="round" icon={<CloseOutlined />} onClick={() => {
                    setFichaIndeferir(ficha)
                    setModalIndeferir(true)
                    // indeferirInscricao(ficha.id, ficha);
                  }}  >
                    Indeferir
                  </Button>
                  <Button
                    style={{ background: 'green' }}
                    type="primary" shape="round"
                    icon={<CheckOutlined />}
                    onClick={() => {
                      deferirInscricao(ficha.id, ficha);
                    }}  >
                    Deferir
                  </Button>

                </div>
              </div>
        </Wrapper>

            )
      )}

    </div>
    </Spin>
      )


}
